<div
  class="card-single"
  [attr.data-aos]="aosAnimation?.type"
  [attr.data-aos-offset]="aosAnimationOffset"
  [attr.data-aos-delay]="aosAnimation?.delay"
>
  @if (icon) {
    <a class="card-icon" [href]="icon.iconLink" [ngStyle]="iconCssStylePosition" [class.disabled]="!icon.iconLink">
      @switch (icon.iconType) {
        @case (IconType.linkedin) {
          <pot-icon-svg-linkedin />
        }
      }
    </a>
  }

  <div class="image-card" [class.reduceWhiteOverlay]="reduceWhiteOverlay">
    @if (mediaType === MediaType.video) {
      <div class="video">
        @if (video) {
          <pl-video [sourceSD]="video.source_sd" [sourceHD]="video.source_hd" [poster]="video.poster" />
        }
      </div>
    } @else {
      <img [src]="imgBackGroundUrl" alt="" [ngStyle]="{ objectFit: imgObjectFit }" loading="lazy" />
    }
  </div>

  <div class="card-single-content" [ngClass]="textAlignCssClass">
    <div>
      <h3 [innerHTML]="title"></h3>
      <p class="description" [innerHTML]="description"></p>
      @if (descriptionSmall) {
        <p class="pot-small-p" [innerHTML]="descriptionSmall"></p>
      }
    </div>
    @if (modalContent) {
      <pot-button class="tw-w-auto" (clicked)="openModal()">{{ 'Learn More' }}</pot-button>
    }
    @if (buttonData) {
      <pot-block-button class="tw-w-full" [data]="buttonData.data" [id]="buttonData.id">
        {{ buttonData.data.label }}
      </pot-block-button>
    }
  </div>
</div>
